/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { DashboardLayout, MenuType } from '../../../components/layout/dashboard/DashboardLayout'
import { AccountLoginSettings } from '../../account/AccountLoginSettings'
import { MyAccountAccessLevelGuard } from './components/MyAccountAccessLevelGuard'

const LoginSettings = () => (
    <MyAccountAccessLevelGuard>
        <DashboardLayout menuType={MenuType.myAccount}>
            <div
                css={css`
                    display: flex;
                    width: 100%;
                `}
            >
                <AccountLoginSettings />
            </div>
        </DashboardLayout>
    </MyAccountAccessLevelGuard>
)

export { LoginSettings }
